import React, { useState, useRef, useEffect } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import InfiniteScroll from 'react-infinite-scroll-component';

export type Option = {
  label: string;
  value: any;
}

type CustomDropdownProps = {
  options: Option[],
    hasMore: boolean,
    initialSelectedOption?: number,
    onSelectedOptionChange?: (option: Option) => void
    loadMore?: () => void
}

const CustomDropdown = ({
                          options,
                          onSelectedOptionChange,
                          initialSelectedOption,hasMore,loadMore
                        }: CustomDropdownProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<Option>(options[initialSelectedOption || 0]);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dropdownRef]);

  return (
      <div className="relative w-full" ref={dropdownRef}>
        <div
            className="transition-all outline-none cursor-pointer
          text-text-md text-gray-900 rounded-md border border-gray-300 bg-white
          focus:shadow-focus focus:border-primary-500
          hover:border-primary-500 shadow-xs
          h-[44px] px-md flex items-center justify-between"
            onClick={() => setIsOpen(!isOpen)}
        >
          {selectedOption.label}
          <span className="material-icons"><FaChevronDown /></span>
        </div>
        {isOpen && (
            <InfiniteScroll
                dataLength={options.length}
                next={loadMore || (() => {})}
                hasMore={hasMore}
                loader={null}
                scrollableTarget="scrollableDiv"
                endMessage={<p className='text-gray-400'>No more data to load.</p>}
            >
            <div id="scrollableDiv"
                className="absolute z-10 w-full border border-gray-300 bg-white mt-1 rounded-md max-h-60 overflow-y-auto"
            >
              {options.map((option, index) => (
                  <div
                      key={index}
                      className={
                        `text-gray-900 hover:bg-primary-50 hover:text-primary-500 px-md h-[44px] flex items-center cursor-pointer
                ${selectedOption === option && 'bg-primary-300'}`
                      }
                      onClick={() => {
                        setSelectedOption(option);
                        onSelectedOptionChange && onSelectedOptionChange(option);
                        setIsOpen(false);
                      }}
                  >
                    {option.label}
                  </div>
              ))}
            </div>
            </InfiniteScroll>
        )}
      </div>
  );
};

export default CustomDropdown;
